import Services from './base-services'
import mapParameters from '../utils/map-parameters'

const service = new Services('dictionary');

export default {
    getMeaning(word: string) {
        const params = mapParameters({
            word: word ? word : null
        });
        return service.get('getMeaning', params);
    },
}
